/**
 * Copyright 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const deleteRole = `mutation DeleteRbacRole($customer_id: String!, $id: String!) {
    deleteRbacRole(customer_id: $customer_id, id: $id)
  }
`;
